import styled from '@emotion/styled';
import { keyframes, css } from 'emotion';

import { TABLET_MIN_WIDTH } from '@ezugi/constants';

const rotate = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(-360deg)
    }
`;

export const rotateClassName = css`
  animation: ${rotate} 2.2s linear infinite;
`;

export const Wrapper = styled.div`
  position: relative;
  @media (max-width: ${TABLET_MIN_WIDTH}px) {
    transform: scale(0.66);
  }
`;
